module.exports = __webpack_public_path__ + "static/media/4-5.de84cdab.mp3";